import { GroupModel } from '@descomplica/dex-models';
import { GetterTree } from 'vuex';

import RootState from '@/store/root_state';
import { GroupState } from './state';
import Sort from '@/helpers/sort';

const getters: GetterTree<GroupState, RootState> = {
  getGroupsByBoardsGroupId: (state, groupGetters) => (boardsGroupId?: number) => {
    if (!boardsGroupId) return [];

    const groups = Object.values(state.groups).filter((group) => {
      return group.boardsGroupId === boardsGroupId;
    });

    return groups
      .sort(Sort.byField('position'))
      .map((group) => new GroupModel(group, groupGetters));
  },
};

export default getters;
